import gql from 'graphql-tag';

export const WorkspaceThemePreferenceMutation = gql`
	mutation WorkspaceThemePreferenceMutation($workspaceAri: ID!, $accountId: ID!, $theme: String!) {
		settings_updateUserPreferencesWorkspace(
			workspaceAri: $workspaceAri
			accountId: $accountId
			theme: $theme
		) {
			theme
		}
	}
`;
